import React, { Component } from 'react'
import { connect } from 'react-redux'
import CollapsableBox from '../containers/CollapsableBox'
import Modal from '../containers/Modal'
import LinkedInput from '../inputs/LinkedInput'
import FlowTable from '../tables/FlowTable'
import DynamicFilterField from './DynamicFilterField'
import { StateHelper, EventSystem, notify, Condition } from 'helpers'
import API from 'API'
import Select from 'react-select'
import Datetime from 'react-datetime'
import moment from 'moment'
import ENDPOINTS from 'config/endpoints'
import { string } from 'helpers'
class Filter extends Component {
  constructor (props) {
    super(props)
    this.state = {
      conditions: {},
      callback: true,
      saveModal: false,
      openModal: false,
      filterName: '',
      savedFilters: {},
      schemas: {},
      loadCounter: 0,
      hasAdvanced: 0,
      toggleAdvanced: false
    }
    this.timer = null
    if (!this.props.deepstream) return
    this.activeFilter = this.props.deepstream.record.getRecord(`users/${this.props.user.id}/filter/${this.props.navigation.path}`)
    this.savedFilters = this.props.deepstream.record.getRecord(`users/${this.props.user.id}/savedFilters/${this.props.navigation.path}`)
  }
  componentDidMount () {
    this.props.namespacefilter && this.setNamespaces()
    this.props.filters.map(async filter => {
      if (filter.advanced) this.setState({ hasAdvanced: ++this.state.hasAdvanced })
      if (filter.type === 'schema') {
        StateHelper.setValueAtPath(this, 'conditions.' + filter.endpoint, {
          operator: filter.operator,
          value: filter.value || '',
          key: '',
          type: filter.type
        })
        var fields = await API.list(filter.endpoint)
        if (!fields.success) return
        fields = fields.data.filter(model => model.name === filter.model)
        this.setState({ schemas: { ...this.schemas, [filter.endpoint]: Object.values(fields[0].fields).filter(field => (filter.exclude || []).indexOf(field.name) === -1) } })
        return
      }
      if (filter.type === 'dynamic') {
        StateHelper.setValueAtPath(this, 'conditions.' + filter.name, {
          fields: [],
          type: filter.type
        })
        return
      }
      StateHelper.setValueAtPath(this, 'conditions.' + filter.key, {
        operator: filter.operator,
        value: filter.value || '',
        type: filter.type,
        logic: filter.logic
      })
    })
    this.activeFilter.whenReady(record => {
      var filter = record.get('filter')
      if (filter !== undefined) {
        this.buildConditionsFromRethink(filter)
      } else {
        this.callback()
      }
    })
    this.savedFilters.whenReady(record => {
      var filters = record.get('filters')
      if (filters !== undefined && (typeof filters === typeof {})) {
        this.setState({ filters: filters })
      }
      record.subscribe('filters', filters => {
        this.setState({ filters: filters })
      })
    })
    if (!this.props.subscribe) return
    EventSystem.subscribe(this.props.subscribe, async a => {
      var val
      while ((val = a.shift())) {
        await this.filter(val[0], val[1], (a.length <= 0)) // only perform callback on last element
      }
    })
  }
  componentWillUnmount () {
    if (this.props.subscribe) EventSystem.unsubscribe(this.props.subscribe)
  }
  buildConditionsFromRethink (conditions) {
    Object.keys(conditions).map(key => {
      var condition = conditions[key]
      if (condition.type === 'hidden') return
      if (this.state.conditions[key]) {
        if (condition.type === 'dynamic') return StateHelper.setValueAtPath(this, 'conditions.' + key + '.fields', condition.fields)
        StateHelper.setValueAtPath(this, 'conditions.' + key + '.value', condition.value)
        if (condition.type === 'operator-select') StateHelper.setValueAtPath(this, 'conditions.' + key + '.operator', condition.value[0])
      }
    })
    this.callback()
  }
  saveConditonsToRethink () {
    var conditions = {}
    Object.keys(this.state.conditions).map(key => {
      var condition = this.state.conditions[key]
      if (!condition.value && (condition.fields && !condition.fields.length)) return
      if (condition.type === 'hidden') return
      conditions[key] = condition
    })
    this.activeFilter.set('filter', conditions)
  }
  callback () {
    if (this.timer !== null) {
      clearTimeout(this.timer)
    }
    this.saveConditonsToRethink()
    var conditions = new Condition()
    conditions.logic('AND')
    Object.keys(this.state.conditions).map(key => {
      var condition = this.state.conditions[key]
      if (key.indexOf('/') > -1) {
        key = this.state.conditions[key].key
      }
      if (condition.type === 'dynamic') {
        if (!condition.fields.filter(field => !((!field.value && !['ISNULL', 'NOTNULL', 'ISEMPTY', 'ISNOTEMPTY'].includes(field.operator)) || !field.operator)).length) return
        conditions.subgroup(group => {
          group.logic('AND')
          condition.fields.map(field => {
            if (!field.value && !['ISNULL', 'NOTNULL', 'ISEMPTY', 'ISNOTEMPTY'].includes(field.operator)) return
            if (!field.value) field.value = ''
            var value = field.value.split(',')
            if (value.length > 1) {
              group.subgroup(multiValue => {
                multiValue.logic('OR')
                value.map(val => multiValue.item(field.key, field.operator, val))
              })
              return
            }
            group.item(field.key, field.operator, field.value)
          })
        })
      }
      if (!condition.value) return
      if ((typeof condition.value === typeof []) && !condition.value.length) return
      key = key.split(',')
      if (key.length > 1 || (typeof condition.value === typeof [])) {
        conditions.subgroup(group => {
          group.logic(condition.logic || 'OR')
          if ((typeof condition.value === typeof [])) {
            condition.value.map(value => group.item(key[0].replace('->', '.'), condition.operator, value))
          } else {
            key.map(column => group.item(column.replace('->', '.'), condition.operator, condition.value))
          }
        })
      } else {
        if (condition.value) {
          conditions.item(key[0].replace('->', '.'), condition.operator, condition.value)
        }
      }
    })
    conditions = conditions.build()['condition.values']
    if (!conditions.items.length && !conditions.subgroups.length) return this.props.callback(null, this.state.namespaces)
    if (!this.state.callback) return
    this.timer = setTimeout(() => {
      this.props.callback(conditions, this.state.namespaces)
    }, 100)
  }
  filter (key, value, update = true) {
    var values
    this.setState({ callback: update })
    if (this.state.conditions[key].type === 'toggles') {
      values = StateHelper.getValueFromPath(this, `conditions.${key}.value`)
      let index
      if ((index = values.indexOf(value)) > -1) {
        values.splice(index, 1)
        StateHelper.setValueAtPath(this, `conditions.${key}.value`, values)
        return this.callback()
      }
      StateHelper.setValueAtPath(this, `conditions.${key}.value`, [...values, value])
      return this.callback()
    } else if (this.state.conditions[key].type === 'toggle') {
      StateHelper.setValueAtPath(this, `conditions.${key}.value`, [...[], value])
      return this.callback()
    }
    this.setState({
      conditions: { ...this.state.conditions, [key]: { ...this.state.conditions[key], value: value } }
    }, this.callback)
  }

  saveFilter () {
    if (!this.state.filterName) return notify.warn('Pick a name for your filter')
    var conditions = {}
    Object.keys(this.state.conditions).map(key => {
      var condition = this.state.conditions[key]
      if (condition.type === 'hidden') return
      conditions[key] = condition
    })

    const sanitizedFilterName = string.sanitizeHTML(this.state.filterName)
    this.setState({ filters: { ...this.state.filters, [string.sanitizeHTML(sanitizedFilterName)]: conditions } }, e => {
      this.savedFilters.set('filters', this.state.filters)
      notify.success('Your filter has been saved as ' + sanitizedFilterName)
      this.setState({ saveModal: false, sanitizedFilterName: '' })
    })
  }

  async deleteFilter (filter) {
    var confirm = await notify.confirm('Are you sure you want to delete ' + filter + '?')
    if (!confirm) return
    delete this.state.filters[filter]
    this.savedFilters.set('filters', this.state.filters)
  }

  loadFilter (conditions) {
    Object.keys(conditions).map(key => {
      var condition = conditions[key]
      if (condition.type === 'hidden') return
      if (this.state.conditions[key]) {
        if (condition.type === 'dynamic') return StateHelper.setValueAtPath(this, 'conditions.' + key + '.fields', condition.fields)
        StateHelper.setValueAtPath(this, 'conditions.' + key + '.value', condition.value)
      }
    })
    this.setState({ openModal: false, loadCounter: ++this.state.loadCounter })
    this.callback()
  }

  async setNamespaces () {
    var result = await API.list(ENDPOINTS.ADMIN.NAMESPACE)
    var namespaceToggles = []
    result.data.map(namespace => {
      if (!namespace.hasOwnProperty('name') || namespace.name.length === 0) return
      namespaceToggles.push({value: namespace.name})
    })
    this.setState({namespaceToggles})
  }

  render () {
    if (Object.keys(this.state.conditions).length === 0) return false
    return (
      <CollapsableBox title='Filter' icon='filter' cols={12} identifier={'filter_widget'} buttons={[
        { icon: 'fa-save', event: () => this.setState({ saveModal: true }), datatip: 'Save filter' },
        { icon: 'fa-folder', event: () => this.setState({ openModal: true }), datatip: 'Show saved filters' },
        { hidden: !this.state.hasAdvanced, icon: 'fa-angle-double-down', event: () => this.setState({ toggleAdvanced: !this.state.toggleAdvanced }), datatip: 'Toggle advanced filters' }]}>
        <div className='filterbox-inner'>
          {this.props.filters.map(filter => {
            if (filter.type === 'search') {
              return (
                <div key={filter.name} className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <input value={this.state.conditions[filter.key].value} key={filter.key} placeholder='Search...' type='text' className='form-control' onKeyUp={e => this.filter(filter.key, e.target.value)} onChange={e => this.filter(filter.key, e.target.value)} />
                  </div>
                </div>
              )
            }
            if (filter.type === 'toggles' || filter.type === 'toggle') {
              return (
                <div className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')} key={filter.name}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8'>
                    {filter.toggles.map(toggle => {
                      return (
                        <button key={toggle.value} onClick={() => this.filter(filter.key, toggle.value)} className={'simple-linkedtoggle simple-linkedtoggle' + ((this.state.conditions[filter.key].value.indexOf(toggle.value) > -1) ? '-active' : '-disabled')}>
                          {toggle.name}
                        </button>
                      )
                    })}
                  </div>
                </div>
              )
            }
            if (filter.type === 'select') {
              return (
                <div key={filter.name} className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <Select
                      options={filter.toggles}
                      labelKey='name'
                      className='filter-select'
                      value={this.state.conditions[filter.key].value}
                      multi
                      onChange={e => this.setState({ conditions: { ...this.state.conditions, [filter.key]: { ...this.state.conditions[filter.key], value: e.map(con => con.value) } } }, this.callback)}
                    />
                  </div>
                </div>
              )
            }
            if (filter.type === 'schema') {
              return (
                <div key={filter.name} className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-5 col-sm-8 flexbox-absolute-center'>
                    <Select
                      options={this.state.schemas[filter.endpoint]}
                      labelKey='name'
                      valueKey='name'
                      className='filter-select'
                      value={this.state.conditions[filter.endpoint].key}
                      onChange={e => this.setState({ conditions: { ...this.state.conditions, [filter.endpoint]: { ...this.state.conditions[filter.endpoint], key: e.name } } }, this.callback)}
                    />
                  </div>
                  <div className='col-md-5 col-sm-8 flexbox-absolute-center'>
                    <input value={this.state.conditions[filter.endpoint].value} key={filter.key} placeholder='Search...' type='text' className='form-control' onKeyUp={e => this.filter(filter.endpoint, e.target.value)} onChange={e => this.filter(filter.endpoint, e.target.value)} />
                  </div>
                </div>
              )
            }
            if (filter.type === 'dynamic') {
              return <DynamicFilterField
                attributes={filter.attributes}
                schema={filter.schema}
                basepath={filter.basepath}
                model={filter.model}
                key={filter.name}
                filter={filter}
                loads={this.state.loadCounter}
                memory={JSON.parse(JSON.stringify(this.state.conditions[filter.name], (k, v) => (k === '$meta') ? undefined : v))}
                callback={data => this.setState({ conditions: { ...this.state.conditions, [filter.name]: { ...this.state.conditions[filter.name], fields: data } } }, this.callback)}
              />
            }
            if (filter.type === 'operator-select') {
              return (
                <div key={filter.name} className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <Select
                      options={filter.toggles}
                      labelKey='name'
                      className='filter-select'
                      value={this.state.conditions[filter.key].value}
                      multi
                      onChange={e => this.setState({ conditions: { ...this.state.conditions, [filter.key]: { ...this.state.conditions[filter.key], value: e.map(con => con.value), operator: (!e.map(con => con.operator)) ? filter.operator : e.map(con => con.operator)[0] } } }, this.callback)}
                    />
                  </div>
                </div>
              )
            }
            if (filter.type === 'datetimepicker') {
              return (
                <div key={filter.name} className={'row ' + (filter.advanced ? (this.state.toggleAdvanced ? '' : 'hidden') : '')}>
                  <div className='col-md-2 col-sm-4'>
                    <span className='filter-name'>{filter.name}</span>
                  </div>
                  <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                    <Datetime renderInput={props =>
                      <div className='input-group'>
                        <input {...props} className='form-control' />
                        <span onClick={() => { this.filter(filter.key, '') }} className='input-group-addon'><i className='fa fa-fw fa-times' /></span>
                      </div>
                    } inputProps={{ placeholder: 'Select a date...' }} value={this.state.conditions[filter.key].value ? moment(this.state.conditions[filter.key].value) : ''} key={filter.key} className='filter-select' closeOnSelect onChange={dateFromUser => { this.filter(filter.key, dateFromUser.toISOString()) }} dateFormat={'YYYY-MM-DD'} timeFormat={'HH:mm:ss'} />
                  </div>
                </div>
              )
            }
          })}
          {this.props.namespacefilter &&
            <div key='namespace_filter' className='row'>
              <div className='col-md-2 col-sm-4'>
                <span className='filter-name'>Namespace</span>
              </div>
              <div className='col-md-10 col-sm-8 flexbox-absolute-center'>
                <Select
                  options={this.state.namespaceToggles}
                  labelKey='value'
                  className='filter-select'
                  value={this.state.namespaces}
                  multi
                  onChange={e => this.setState({ namespaces: e } , this.callback)}
                />
              </div>
            </div>
          }
          {!!this.state.hasAdvanced && <a className='btn btn-default btn-sm pull-right' onClick={e => this.setState({ toggleAdvanced: !this.state.toggleAdvanced })}>Toggle {this.state.hasAdvanced} advanced filters</a>}
        </div>
        <Modal isOpen={this.state.saveModal} close={e => this.setState({ saveModal: false, filterName: '' })} title='Save filter' buttons={[
          { text: 'Save', event: () => this.saveFilter() }]}>
          <div className='row'>
            <div className='col-md-12 form-'>
              <LinkedInput context={this} path='filterName' placeholder='Name your filter' />
            </div>
          </div>
        </Modal>
        <Modal isOpen={this.state.openModal} close={e => this.setState({ openModal: false })} title='Load filters'>
          <FlowTable data={Object.keys(this.state.filters || {}).map(filter => [<a className='table-link' onClick={e => this.loadFilter(this.state.filters[filter])}><i className='fa fa-search' /></a>, filter, <a className='table-link pull-right' onClick={e => this.deleteFilter(filter)}><i className='fa fa-times' /></a>])}>
            <tr>
              <th className='buttons' />
              <th>Name</th>
              <th className='buttons' />
            </tr>
          </FlowTable>
        </Modal>
      </CollapsableBox>
    )
  }
}
// eslint-disable-next-line
Filter = connect(state => state.siteReducer)(Filter)
export default Filter



// WEBPACK FOOTER //
// ./src/components/basic/misc/Filter.js